import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import React, { useRef } from 'react';

import { UploadsTable } from 'components/UploadsTable';
import { useSettings } from 'hooks/useSettings';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function PersonalUploads() {
  const { directories } = useSettings();
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <HideStationSelector>
      <TablePageLayout title="Persoonlijk Dossier">
        <UploadsTable
          id="uploads-table"
          ref={tableRef}
          // deletable={false}
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op naam of bestandsmap',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [
                { name: { _ilike: `%${str}%` } },
                { attachmentType: { _ilike: `%${str}%` } },
              ]),
            }),
          }}
          selectProps={{
            filter: {
              clientId: { _isNull: false },
              attachmentType: { _nin: directories.map((x) => x.name) },
            },
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
